import { render, staticRenderFns } from "./dialogSendEmail.vue?vue&type=template&id=002f8c8c&scoped=true&"
import script from "./dialogSendEmail.vue?vue&type=script&lang=js&"
export * from "./dialogSendEmail.vue?vue&type=script&lang=js&"
import style0 from "./dialogSendEmail.vue?vue&type=style&index=0&id=002f8c8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f8c8c",
  null
  
)

export default component.exports